var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"ml-2",on:{"click":function($event){return _vm.showPanel()}}},[_vm._v("fa-solid fa-circle-info")])}
var staticRenderFns = []

export { render, staticRenderFns }